let infosBannerItem = {
    delimiters: ['%%', '%%'],
    props: {
        infosBanner: null
    },
    data() {
        return {

        };
    },
    computed: {
        store_displayInfosBanner() {
            return this.$store.getters.displayInfosBanner
        }
    },
    methods: {
        changeInfosBanner() {
            this.$store.dispatch('changeInfosBanner')
        }
    },
    template: `
        <div v-if="infosBanner">
            <div class="py-3 px-6 flex justify-center items-center">
                <div class="flex items-center">
                    <div v-html="infosBanner.title.rendered" class="title pl-4"></div>
                </div>
                <div class="cursor-pointer px-6" :class="{'scale-1': store_displayInfosBanner}" @click="changeInfosBanner" v-show="infosBanner.content.rendered.length > 0">
                    <i class="fal fa-chevron-down"></i>
                </div>
            </div>
            <!-- <transition name="open"> -->
            <div :class="store_displayInfosBanner ? 'h-auto opacity-100':'h-0 opacity-0'" class="ArticleContent row flex-col items-center transition-all duration-500 ease-in-out">
                <div class="image pt-4 px-16 pb-16" v-if="!!infosBanner.featured_image_small_large_src">
                    <img :src="infosBanner.featured_image_small_large_src" alt="" />
                </div>
                <div class="pt-4 px-16 pb-16 text-center" v-html="$options.filters.splitMore(infosBanner.content.rendered)"></div>
            </div>
            <!-- </transition> -->
        </div>`
};